<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <p-card>
    <div class="p-fluid lk-eu-mobile-form-fields">
      <div class="field">
        <label class="font-medium required-field">Клиент</label>
        <crm-client-auto-complete
          [isError]="$any(errors?.client)"
          [(selectedClient)]="car.client"
          [showClear]="true"
          [customSearch]="false"
          (selectedClientChange)="onClientChange()"
          appendTo="body"></crm-client-auto-complete>
        <small
          *ngIf="errors?.client"
          class="p-error">
          {{ errors.client | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium">Владелец</label>
        <crm-external-user-single-select
          [disabled]="!car?.client?.id"
          [showClear]="true"
          [isError]="$any(errors?.owner)"
          [clientIds]="clientIdsFilter"
          [requireFilter]="true"
          [(selectedEntity)]="car.owner"
          appendTo="body"></crm-external-user-single-select>
        <small
          *ngIf="errors?.owner"
          class="p-error">
          {{ errors.owner | join }}
        </small>
      </div>

      <p-messages
        *ngIf="!(form$ | async)?.isShowDelete"
        severity="info">
        <ng-template pTemplate="">
          <div class="flex gap-2 align-items-center">
            <i
              class="pi pi-exclamation-circle"
              style="font-size: 1.3rem"></i>
            <ul [style.padding-inline-start.px]="20">
              <li>Введите только регистрационный номер транспортного средства</li>
              <li>Пример: А001МР97</li>
            </ul>
          </div>
        </ng-template>
      </p-messages>

      <div class="field">
        <label class="font-medium required-field">Гос. номер ТС</label>
        <crm-input-text
          [(value)]="car.carNumber"
          [isError]="$any(errors?.carNumber)"></crm-input-text>
        <small
          *ngIf="errors?.carNumber"
          class="p-error">
          {{ errors.carNumber | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Помещения</label>
        <crm-room-multi-select
          [isError]="$any(errors?.rooms)"
          [(selectedRooms)]="car.rooms"
          [filialIds]="roomFilialIdsFilter"
          [isFloatLabel]="false"
          [onlyWithHikvisionCameras]="true"
          [onlyParkingAvailable]="true"
          [autoSelectOne]="true"
          (selectedRoomsChange)="onRoomsChange($event)"
          appendTo="body">
        </crm-room-multi-select>
        <small
          *ngIf="errors?.rooms"
          class="p-error">
          {{ errors.rooms | join }}
        </small>
      </div>

      <div class="field">
        <label class="font-medium required-field">Категория ТС</label>
        <crm-car-category-single-select
          [isError]="$any(errors?.category)"
          [onlyParkingAccessibleRooms]="true"
          [roomIds]="categoryFilterRoomIds"
          [disabled]="!car.rooms?.length"
          [placeholder]="!car.rooms?.length ? 'Выберите помещения' : '\u00A0'"
          [(selectedCategory)]="car.category"
          appendTo="body">
        </crm-car-category-single-select>
        <small
          *ngIf="errors?.category"
          class="p-error">
          {{ errors.category | join }}
        </small>
      </div>
    </div>
  </p-card>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success"
        (onClick)="saveCar()"></crm-button>

      <ng-container *ngIf="(form$ | async)?.isShowDelete">
        <crm-button
          *ngIf="!car['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteCar()"></crm-button>

        <crm-button
          *ngIf="car['deleted']"
          label="Восстановить"
          styleClass="p-button-text"
          (onClick)="restoreCar()"></crm-button>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
